import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCallResponse } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { CommonSearch, updateSearchStatus } from "../common/CommonSearch";
import {
  FilterContainsInsensitive,
  FilterEqual,
  FilterKeyWord,
} from "../common/FilterCondition";
import { TableHeader } from "../common/Table/TableHeaderLabel";

const DownloadParidhanAadesh = () => {
  const [usersData, setuserData] = useState();
  // eslint-disable-next-line no-unused-vars
  const [AllUsersData, setAllUsersData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [textField, settextField] = useState("LotNo");
  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);
  // const [TenderNo, setTenderNo] = useState();
  // const [LotNo, setLotNo] = useState();
  const [itemPerPage, setItemPerPage] = useState(10);

  const { authenticated } = Auth();

  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  const [pageCount, setPageCount] = useState(0); // List Data pagging manage

  const SearchFilterModule = {
    collectionSeason: new Date().getFullYear().toString(),
    tenderNo: "",
    lotNo: "",
  };

  // Search Model
  const [search, setSearch] = useState(SearchFilterModule);

  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getParidhanAadeshDetailsByDFO();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      orderClick ? setorder("asc") : setorder("desc");
      getPageCount();
      getParidhanAadeshDetailsByDFO();
      setIsClear(false);
      setIsSearch(false);
      // reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  const paggingManage = (totalRecord, isRecordGet = true) => {
    if (isRecordGet === false) {
      setPageCount(0);
      paggingDisabled();
    } else {
      setPageCount(parseInt(totalRecord));
      paggingDisabled(
        pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
        pageLimit === 0
      );
    }
  };

  const filterManage = () => {
    let filter = "";

    filter = "&$filter=";
    if (authenticated.role === "DFO") {
      filter = FilterKeyWord(
        filter,
        "districtId",
        authenticated.district,
        "eq"
      );
    }
    filter = FilterEqual(filter, "collectionSeason", search.collectionSeason);
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);
    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);

    if (filter === "&$filter=") {
      filter = "";
    }

    return filter;
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `LotDetails/getParidhanAadeshListByDFO?${filterManage()}`
      ).then((res) => {
        if (res.success) paggingManage(parseInt(res.data.length) || 0);
        else paggingManage(0, false);
      });
    }
  };

  const getParidhanAadeshDetailsByDFO = async (firstRequest) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `LotDetails/getParidhanAadeshListByDFO?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setuserData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingManage(pageCount);
          }
        } else {
          setuserData();
          paggingManage(0, false);
        }
        setloading(false);
      });
    }
  };

  //table header Click manage
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const tableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  const fields = [
    {
      key: "tenderNo",
      _style: { width: "10%" },
      label: tableHeaderSet("Tender No", "tenderNo"),
    },
    {
      key: "lotNo",
      _style: { width: "7.5%" },
      label: tableHeaderSet("Lot No", "lotNo"),
    },
    {
      key: "godownName",
      _style: { width: "15%" },
      label: tableHeaderSet("Godown Name", "godownName"),
    },
    {
      key: "paDateFormat",
      label: tableHeaderSet("DateTime (dd/mm/yyyy)", "paridhanAadeshDate"),
      _style: { width: "7.5%" },
    },
    {
      key: "amount",
      _style: { width: "7.5%" },
      label: tableHeaderSet("Amount", "amount"),
    },
    {
      key: "displayInstallment",
      label: "Installmant",
      _style: { width: "7.5%" },
      sorter: false,
      filter: false,
    },

    {
      key: "userName",
      _style: { width: "15%" },
      label: tableHeaderSet("User Name", "userName"),
    },
    {
      key: "mobileNo",
      _style: { width: "7.5%" },
      label: "Mobile No",
    },

    {
      key: "DownloadParidhanAadesh",
      label: "Download",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };

  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModule });
    setuserData();
  };

  let additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isLotNumberDisplay={true}
    />
  );

  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Paridhan Aadesh List"
      loading={loading}
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      id="id"
    />
  );
};

export default DownloadParidhanAadesh;
